var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSampleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 27.245 25.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 27.245,
    height: 25.719,
    fill: "#b0b6d2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M.018,20.058a5.253,5.253,0,0,1,1.665-4.02Q7.847,9.867,14.018,3.7a.483.483,0,0,0,.116-.562A2.43,2.43,0,0,1,16.611.005a2.332,2.332,0,0,1,1.55.684c2.271,2.272,4.556,4.529,6.8,6.822a2.4,2.4,0,0,1-1.143,4.024,6.022,6.022,0,0,1-1.335-.025.787.787,0,0,0-.5.129C17.843,15.76,13.722,19.9,9.575,24.016A5.354,5.354,0,0,1,3.8,25.4a5.425,5.425,0,0,1-3.78-4.49,4.837,4.837,0,0,1-.007-.847M18.2,13.107l-.071-.128c-.094-.005-.189-.015-.283-.015-3.466,0-6.931-.006-10.4.012a.994.994,0,0,0-.611.289c-1.3,1.276-2.588,2.568-3.875,3.859a3.9,3.9,0,0,0-1.254,3.6A3.752,3.752,0,0,0,4.412,23.84a3.682,3.682,0,0,0,3.877-.911c2.521-2.478,5.006-4.993,7.51-7.488.79-.787,1.6-1.557,2.4-2.334m2.667-2.753-5.5-5.528-6.445,6.45h.516c3.1,0,6.2-.033,9.3.021a2.217,2.217,0,0,0,2.079-.878c.016-.023.035-.045.051-.065M15.6,2.429a7.526,7.526,0,0,0,.586.784c1.211,1.229,2.434,2.446,3.655,3.665q1.4,1.395,2.8,2.785a.714.714,0,0,0,.8.249.768.768,0,0,0,.217-1.357q-2.069-2.072-4.138-4.143c-.82-.82-1.647-1.633-2.464-2.456a.716.716,0,0,0-.885-.178c-.215.118-.345.39-.561.651",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M267.881,161.669a2.461,2.461,0,0,1-1.517,2.274,2.4,2.4,0,0,1-2.661-.509,2.321,2.321,0,0,1-.507-2.688c.456-.921.99-1.806,1.534-2.678a.79.79,0,0,1,1.352-.033c.557.881,1.075,1.788,1.569,2.706a3.8,3.8,0,0,1,.23.928m-2.456-1.493c-.267.47-.506.835-.687,1.226a.693.693,0,0,0,.2.877.662.662,0,0,0,.892.038.949.949,0,0,0,.321-.741,8.61,8.61,0,0,0-.725-1.4",
    transform: "translate(-240.636 -144.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M75.521,185.531c-1.008.813-1.332.9-1.732.479s-.291-.747.585-1.812a3.472,3.472,0,0,1-.536-.384.845.845,0,0,1-.024-1.244.817.817,0,0,1,1.206.066c.154.144.279.318.443.508.23-.22.4-.4.591-.562a.815.815,0,0,1,1.179.009.866.866,0,0,1-.035,1.218c-.157.16-.335.3-.415.369a12.194,12.194,0,0,1,.663,1.289.637.637,0,0,1-.207.522c-.781.7-1.222-.044-1.719-.459",
    transform: "translate(-67.307 -166.851)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleIcon);
export default __webpack_public_path__ + "static/media/sampleIcon.7ac97b997daaf25a2ab1ed806e28fc9c.svg";
export { ForwardRef as ReactComponent };